// TODO: visit the url below for variables of antd components
// https://github.com/ant-design/ant-design/blob/master/components/style/themes/default.less

module.exports = {
  // primary
  primaryLight1: "#FFFFFF",
  primaryLight2: "#ECF2FF",
  primaryLight3: "#AAC1FA",

  primarySurface: "#E6EEFF",
  primarySurfaceHover: "#CBDBFF",

  primaryBorder: "#1656FD",
  primaryBorderHover: "#0243EC",

  primaryShape: "#0243EC",
  primaryShapeHover: "#002583",
  primaryShapeActive: "#001753",

  primaryText: "#002583",
  primaryTextHover: "#001753",
  primaryTextActive: "#000B27",

  // neutrals
  neutralsPageBackground: "#FBFBFD",
  neutralsComponentBackground1: "#F4F6FA",
  neutralsComponentBackground2: "#E6EAF5",

  neutralsSurface: "#F4F6FA",
  neutralsSurfaceHover: "#EEF1F8",
  neutralsSurfaceDisabled: "#EEF3F8",

  neutralsBorder: "#B6C2E2",
  neutralsBorderHover: "#A7B5DA",
  neutralsBorderDisabled: "#CBD4EC",

  neutralsShapeTertiary: "#6677A2",
  neutralsShapeTertiaryHover: "#445275",
  neutralsShapeTertiaryActive: "#333E5A",
  neutralsShapeTertiaryDisabled: "#B8C4E5",

  neutralsTextTertiary: "#445275",
  neutralsTextTertiaryDisabled: "#B9C4D9",

  neutralsShapeSecondary: "#445275",
  neutralsShapeSecondaryHover: "#333E5A",
  neutralsShapeSecondaryActive: "#333E5A",
  neutralsShapeSecondaryDisabled: "#B8C4E5",

  neutralsTextSecondary: "#333E5A",
  neutralsTextSecondaryDisabled: "#B9C4D9",

  neutralsTextPrimary: "#11151F",
  neutralsTextPrimaryDisabled: "#B9C4D9",

  // semantics-success
  successSurface: "#D8F7E6",
  successSurfaceHover: "#A4E8C2",

  successBorder: "#1E9850",
  successBorderHover: "#0D823C",

  successShape: "#0D823C",
  successShapeHover: "#00692A",
  successShapeActive: "#005122",

  successText: "#00692A",
  successTextHover: "#005122",
  successTextActive: "#001C0D",

  // semantics-warning
  warningSurface: "#FFEFE4",
  warningSurfaceHover: "#FFCEAE",

  warningBorder: "#FF7A2A",
  warningBorderHover: "#FA5C00",

  warningShape: "#FA5C00",
  warningShapeHover: "#EE5800",
  warningShapeActive: "#C74900",

  warningText: "#EE5800",
  warningTextHover: "#C74900",
  warningTextActive: "#A43C00",

  // semantics-error
  errorSurface: "#FFE5E8",
  errorSurfaceHover: "#FFB1B9",

  errorBorder: "#EE1E34",
  errorBorderHover: "#E8132A",

  errorShape: "#E8132A",
  errorShapeHover: "#D20319",
  errorShapeActive: "#9C0010",

  errorText: "#D20319",
  errorTextHover: "#9C0010",
  errorTextActive: "#72000C",

  // semantics-info
  infoSurface: "#E8F1FF",
  infoSurfaceHover: "#D0E2FF",

  infoBorder: "#1C6BFF",
  infoBorderHover: "#1062FF",

  infoShape: "#1062FF",
  infoShapeHover: "#0250EC",
  infoShapeActive: "#0046D3",

  infoText: "#0250EC",
  infoTextHover: "#0046D3",
  infoTextActive: "#003AAD",

  // additional-hue246
  hue246Surface: "#EEEDFF",
  hue246SurfaceHover: "#DDD9FF",

  hue246Border: "#6F5CDC",
  hue246BorderHover: "#4B35B5",

  hue246Shape: "#4B35B5",
  hue246ShapeHover: "#392494",
  hue246ShapeActive: "#2A1770",

  hue246Text: "#392494",
  hue246TextHover: "#2A1770",
  hue246TextActive: "#100740",

  // additional-hue279
  hue279Surface: "#F7E8FF",
  hue279SurfaceHover: "#EFD1FF",

  hue279Border: "#AF35FE",
  hue279BorderHover: "#9F1FF3",

  hue279Shape: "#9F1FF3",
  hue279ShapeHover: "#8910D9",
  hue279ShapeActive: "#6306A0",

  hue279Text: "#8910D9",
  hue279TextHover: "#6306A0",
  hue279TextActive: "#470375",

  // additional-hue191
  hue191Surface: "#E9FBFF",
  hue191SurfaceHover: "#BCF2FF",

  hue191Border: "#11B3F3",
  hue191BorderHover: "#019AD8",

  hue191Shape: "#019AD8",
  hue191ShapeHover: "#00668F",
  hue191ShapeActive: "#00577A",

  hue191Text: "#00668F",
  hue191TextHover: "#00577A",
  hue191TextActive: "#004865",

  // additional-hue310
  hue310Surface: "#FFF0FF",
  hue310SurfaceHover: "#FFDCF9",

  hue310Border: "#DF2F9B",
  hue310BorderHover: "#BD0A78",

  hue310Shape: "#BD0A78",
  hue310ShapeHover: "#8E0057",
  hue310ShapeActive: "#430029",

  hue310Text: "#8E0057",
  hue310TextHover: "#430029",
  hue310TextActive: "#2B001B",

  // additional-hue173
  hue173Surface: "#C7FCF6",
  hue173SurfaceHover: "#77F3E6",

  hue173Border: "#17C1B0",
  hue173BorderHover: "#079183",

  hue173Shape: "#079183",
  hue173ShapeHover: "#02685E",
  hue173ShapeActive: "#01534A",

  hue173Text: "#02685E",
  hue173TextHover: "#01534A",
  hue173TextActive: "#003D37",

  // additional-hue73
  hue73Surface: "#F1FFBF",
  hue73SurfaceHover: "#D1F960",

  hue73Border: "#79A00B",
  hue73BorderHover: "#425900",

  hue73Shape: "#425900",
  hue73ShapeHover: "#334500",
  hue73ShapeActive: "#263400",

  hue73Text: "#334500",
  hue73TextHover: "#263400",
  hue73TextActive: "#1B2500",
};
